export function getStringOrFirstInArray(param?: string | string[]) {
  // eslint-disable-next-line no-nested-ternary
  return typeof param === 'undefined'
    ? ''
    : typeof param === 'string'
    ? param
    : param[0];
}
